export const languages = [
  'english', 'hindi', 'marathi', 'gujarathi', 'kannada', 'tamil', 'telugu'
];
